/* eslint-disable no-nested-ternary */

import React, { useContext } from 'react';
import { TRANSLATE } from '../../constants/languages';
import { IProductStatusProps } from './Types';
import './ProductStatus.scss';

const ProductStatus: React.FC<IProductStatusProps> = ({ status }): JSX.Element => {
  const productStatusText =
    status === 'IN_STOCK'
      ? TRANSLATE.ua.available
      : status === 'UNDER_THE_ORDER'
      ? TRANSLATE.ua.underOrder
      : status === 'EXPECTING'
      ? TRANSLATE.ua.expecting
      : TRANSLATE.ua.unavailable;

  return (
    <div className={`product-status product-status_${status ? status.toLocaleLowerCase() : 'out_of_stock'}`}>
      <h2>{productStatusText}</h2>
    </div>
  );
};

export default ProductStatus;
